module.exports = __webpack_public_path__ + "static/media/thx.f2ae8db9.svg";